import {
  Obj
} from '../Object.lib';
import {
  COLLECTION__EMPLOYERS,
  readLoopbackRecord
} from '../services/BE/loopback.api';
import {
  trim
} from '../String.lib';

const cache = {};
export default async function fetchEmployerName({
  employerId
}) {
  try {
    if (cache[employerId]) {
      return cache[employerId];
    }
    return (
      cache[employerId] = trim(
        Obj(
          await readLoopbackRecord({
            collection: COLLECTION__EMPLOYERS,
            where: { id: employerId },
            fields: ['name'],
            limit: 1
          })
        ).name
      )
    );
  }
  catch (error) {
    console.error(error);
  }
  return '';
}
